
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const Inicio = lazy(() => import('../pages/inicio/page'));
const Perfiles = lazy(() => import('../pages/perfiles/page'));
const Dashboard = lazy(() => import('../pages/dashboard/page'));
const Auditoria = lazy(() => import('../pages/auditoria/page'));
const Capacitacion = lazy(() => import('../pages/capacitacion/page'));
const Certificaciones = lazy(() => import('../pages/certificaciones/page'));
const Curriculum = lazy(() => import('../pages/curriculum/page'));
const Evaluaciones = lazy(() => import('../pages/evaluaciones/page'));
const Reportes = lazy(() => import('../pages/reportes/page'));
const Configuracion = lazy(() => import('../pages/configuracion/page'));
const Login = lazy(() => import('../pages/login/page'));
const Registro = lazy(() => import('../pages/registro/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/registro',
    element: <Registro />,
  },
  {
    path: '/login',
    element: <Login />,
  },
  {
    path: '/',
    element: <ProtectedRoute><Inicio /></ProtectedRoute>,
  },
  {
    path: '/perfiles',
    element: <ProtectedRoute><Perfiles /></ProtectedRoute>,
  },
  {
    path: '/dashboard',
    element: <ProtectedRoute><Dashboard /></ProtectedRoute>,
  },
  {
    path: '/auditoria',
    element: <ProtectedRoute><Auditoria /></ProtectedRoute>,
  },
  {
    path: '/capacitacion',
    element: <ProtectedRoute><Capacitacion /></ProtectedRoute>,
  },
  {
    path: '/certificaciones',
    element: <ProtectedRoute><Certificaciones /></ProtectedRoute>,
  },
  {
    path: '/curriculum',
    element: <ProtectedRoute><Curriculum /></ProtectedRoute>,
  },
  {
    path: '/evaluaciones',
    element: <ProtectedRoute><Evaluaciones /></ProtectedRoute>,
  },
  {
    path: '/reportes',
    element: <ProtectedRoute><Reportes /></ProtectedRoute>,
  },
  {
    path: '/configuracion',
    element: <ProtectedRoute><Configuracion /></ProtectedRoute>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
